import * as angular from "angular";
import * as moment from "moment";
import * as _ from "lodash";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import DeleteDefectName, { openDeleteDefect } from "./deleteDefect.controller";
import { apsCommands } from "../../shared/dto/aps.commands";
import { apsEnums } from "../../shared/dto/aps.enums";
import GobActivity from "../../models/activity/gobActivity";
import DefectActivity from "../../models/activity/defectActivity";
import LoaderServiceName, {
  LoaderService,
} from "../../components/loader/loader.service";
import DefectServiceName, {
  DefectService,
} from "../../services/defects/defect.service";
import CriticalDefectServiceName, {
  CriticalDefectService,
} from "../../services/defects/criticalDefectService";
import NotifyServiceName, {
  NotifyService,
} from "../../services/notify/notify.service";
import AuthDataServiceName, {
  AuthDataService,
} from "../../services/auth/authData.service";
import DateUtilityService from "../../services/utility/dateutility.service";
import UIUtilityServiceName, {
  EnumOption,
  UIUtilityService,
} from "../../services/utility/uiUtility.service";
import {
  MachineActivity,
  SectionActivity,
  ShopActivity,
} from "../../models/activity/shopActivity";
import NewGuidServiceName, {
  NewGuidService,
} from "../../services/utility/newguid.service";
import PlantServiceName, {
  PlantService,
} from "../../services/plant/plant.service";
import { StateParams } from "../../common";
import { Enums, Strings } from "../../shared/config/constant.module";
import template from "./viewDefect.tpl.html";
import isNullOrUndefined from "../../services/utility/isNullOrUndefined";
import EquipmentServiceName, { EquipmentService } from "../../services/equipment/equipment.service";

let requires = [
  DeleteDefectName,
  LoaderServiceName,
  DefectServiceName,
  CriticalDefectServiceName,
  NotifyServiceName,
  AuthDataServiceName,
  UIUtilityServiceName,
  NewGuidServiceName,
  PlantServiceName,
  EquipmentServiceName
];

interface ViewDefectCtrl {
  vm: DefectActivity;
  minRejectEnd(): Date;
  commentForm: any;
  mnrForm: any;
  mntForm: any;
  moldLossForm: any;
  defectQAForm: any;
  defect: apsViewModels.DefectActivity;
  defectNewComment: string;
  equipment: string;
  machineNumber: number;
  dropName: string;
  sectionName: string;
  gobName: string;
  severityName: string;
  machine: MachineActivity;
  section: SectionActivity;
  gob: GobActivity;
  showCauses: boolean;
  timeZoneId: string;
  isMoldRejectInUse: boolean;
  rejectStart: Date;
  rejectEnd: Date;
  theFuture: Date;
  minTime: Date;
  requalification: boolean;
  requalificationDateTime: Date;
  isEquipmentFailure: boolean;
  maintenanceStart: Date;
  maintenanceEnd: Date;
  isFoodCertifiable: boolean;
  maintenanceResolution: string;
  discardMold: boolean;
  discardMoldOptions: any;
  discardInvalidMolds: boolean;
  moldLossEquipment: apsEnums.EquipmentType;
  moldLossEquipments: EnumOption[];
  moldLoss: apsCommands.AddMoldLoss;
  showMoldLoss: boolean;
  showMoldLossStatus: boolean;
  moldLossStatusList: apsViewModels.MoldLossResponse;
  role: string;
  readOnly: boolean;
  canComment: boolean;
  canRequalify: boolean;
  isMaintenance: boolean;
  isCERole: boolean;
  isHERole: boolean;
  disableEquipment: boolean;
  machineDefectQuestions: any[];
  defaultMachineDefectQuestions: any[];
  cancel(): void;
  formatTime(time: Date | moment.Moment): string;
  defectCommentIsValid(): boolean;
  addDefectComment(): void;
  deleteDefect(): void;
  reviewCausesAndCoursesOfAction(): void;
  updateMNRData(): void;
  hasMNRDataChange(): boolean;
  hasMNTDataChange(): boolean;
  drawDefect(): void;
  openCriticalDefectReport(): void;
  showRequalification(): boolean;
  requalificationToggled(): void;
  updateMNTData(): void;
  updateMNTResolution(): void;
  getMoldLossData(): apsCommands.AddMoldLoss;
  toggleMoldLossStatus(): void;
  addHeldPallets(): void;
  setMoldLossOptions(): void;
  getSelectedDefectsQuestions(): any[];
  invokeMachineDefectQuestions(isMnr: boolean): any;
  addHeldPalletsForm: any;
  heldPalletStart: number;
  heldPalletEnd: number;
  removeHeldPallet(heldPallets: apsViewModels.DefectDetailsHeldPallet): void;
}

export interface ViewDefectData {
  defect: DefectActivity;
  gob: GobActivity;
  defectId: string;
  readOnly: boolean;
  canComment: boolean;
  plantId: string;
}

export function openViewDefect(
  data: ViewDefectData,
  $modal: mm.foundation.modal
): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: "ViewDefectCtrl as vm",
    resolve: {
      data: () => data,
    },
  }).result;
}

export default angular
  .module("aps.controller.viewDefects", requires)
  .controller("ViewDefectCtrl", viewDefectCtrl).name;

function viewDefectCtrl(
  $modalInstance: mm.foundation.modalInstance,
  $modal: mm.foundation.modal,
  loaderService: LoaderService,
  defectService: DefectService,
  criticalDefectService: CriticalDefectService,
  data: ViewDefectData,
  notifyService: NotifyService,
  authDataService: AuthDataService,
  uiUtilityService: UIUtilityService,
  newGuidService: NewGuidService,
  plantService: PlantService,
  $stateParams: StateParams,
  $interval: angular.IIntervalService,
  equipmentService: EquipmentService
) {
  var vm = <ViewDefectCtrl>this;
  var shopActivity = <ShopActivity>{};
  vm.timeZoneId = "";
  var shopId = "";

  vm.readOnly = data ? data.readOnly : false;
  vm.canComment = data ? data.canComment : false;
  vm.isMaintenance = false;
  vm.isCERole = false;
  vm.isHERole = false;
  var role = authDataService.getSelectedRoleLocation();
  vm.role = role.role.roleName;
  if (
    vm.role === "CE Day Mechanic" ||
    vm.role === "CE Shift Mechanic" ||
    vm.role === "Maintenance Manager" ||
    vm.role === "Selecting Tank Manager" ||
    vm.role === "Selecting Shift Supervisor" ||
    vm.role === "Finished Ware Manager" ||
    vm.role === "Quality Control Supervisor" ||
    vm.role === "Selecting Maintenance Supervisor" ||
    vm.role === "Shift Electrician" ||
    vm.role === "Day Electrician" ||
    vm.role === "APSIO Administrator"
  ) {
    vm.isMaintenance = true;
  }
  if (
    vm.role === "Quality Control Supervisor" ||
    vm.role === "Quality Control Manager" ||
    vm.role === "CE Inspector" ||
    vm.role === "Finished Ware Manager" ||
    vm.role === "Tank Manager" ||
    vm.role === "CE Shift Supervisor" ||
    vm.role === "Plant Manager"
  ) {
    vm.isCERole = true;
  } else if (vm.role === "Machine Operator") {
    vm.isHERole = true;
  }

  vm.canRequalify = authDataService.isColdEndOperator();
  vm.isFoodCertifiable = false;
  var setTheFuture = function () {
    var nextFuture = moment().endOf("minute").toDate();
    if (vm.theFuture !== nextFuture) {
      vm.theFuture = nextFuture;
    }
  };

  setTheFuture();
  $interval(setTheFuture, 1000);

  var getDefectEquipment = function () {
    defectService.getDefectEquipment().then(function (data) {
      var equipment = _.find(data, { id: vm.defect.equipmentId });
      if (equipment) {
        vm.equipment = equipment.name;
      }
    });
  };

  var getMoldLossData = function () {
    var moldLoss = vm.moldLoss;
    moldLoss.isRejectInvalidMolds = vm.discardInvalidMolds;
    moldLoss.isRejectMold = vm.discardMold;
    return moldLoss;
  };

  vm.discardMoldOptions = [
    { name: true, value: "YES" },
    { name: false, value: "NO" },
    { name: undefined, value: "N/A" },
  ];

vm.setMoldLossOptions = function () {
  plantService.getPlants().then(plants => {
    this.plants = plants;
    this.selectedPlant = this.plants.filter(p => p.id === data.plantId)[0];

    vm.moldLossEquipments = [];
    if (this.selectedPlant.name === 'Lawrenceburg') {
      vm.moldLossEquipments.push({
        value: null,
        text: 'N/A'
      });
    }

equipmentService.getShop(shopId)
.then((activeEquipment: apsViewModels.EquipmentDetail[]) => {

    if (activeEquipment.some(e => e.type === apsEnums.EquipmentType.Multi)) {
        vm.moldLossEquipments.push({
            value: apsEnums.EquipmentType.Multi,
          text: 'Multi'
        });
  }

  if (activeEquipment.some(e => e.type === apsEnums.EquipmentType.MX4)) {
    vm.moldLossEquipments.push({
      value: apsEnums.EquipmentType.MX4,
      text: 'MX4'
    });
  }

  if (activeEquipment.some(e => e.type === apsEnums.EquipmentType.FlexM)) {
    vm.moldLossEquipments.push({
      value: apsEnums.EquipmentType.FlexM,
      text: 'FlexM'
    });
  }

  if (activeEquipment.some(e => e.type === apsEnums.EquipmentType.WBF) && this.selectedPlant.name !== 'Elmira') {
    vm.moldLossEquipments.push({
      value: apsEnums.EquipmentType.WBF,
      text: 'WBF'
    });
    }


    const currentValueIsValid = vm.moldLossEquipments.some(
        x => x.value === vm.defect.moldLossEquipment
    );

    if (currentValueIsValid) {
        vm.moldLossEquipment = vm.defect.moldLossEquipment;
    }
    else if (this.selectedPlant.name === "Elmira") {
        vm.moldLossEquipment = apsEnums.EquipmentType.FlexM;
    }
    else if (this.selectedPlant.name === "Lawrenceburg") {
        vm.moldLossEquipment = null;
    }
});
  });
};

  plantService
    .getPlatFeatureSettings($stateParams.plantId)
    .then(function (tmpDat) {
      if (tmpDat && tmpDat.config) {
        var tmp = JSON.parse(tmpDat.config);
        var userRoleLocation = authDataService.getSelectedRoleLocation();
        if (tmp && tmp.moldLoss && tmp.moldLoss.shops) {
          vm.showMoldLoss =
            (_.includes(tmp.moldLoss.shops, "*") ||
              _.includes(tmp.moldLoss.shops, vm.machine.shop.id)) &&
            (_.includes(tmp.moldLoss.roles, "*") ||
              _.includes(tmp.moldLoss.roles, userRoleLocation.role.roleId));
          if (vm.showMoldLoss) {
            vm.setMoldLossOptions();
            vm.discardInvalidMolds = undefined;
            if (vm.isHERole) {
              defectService
                .getMoldRejectStatus(vm.defect.id)
                .then(function (data) {
                  vm.discardMold = data;
                });
            } else {
              vm.discardMold = (apsEnums.EquipmentType[vm.defect.moldLossEquipment] === undefined);
            }
          }
        }
      }
    });

  vm.toggleMoldLossStatus = () => {
    vm.showMoldLossStatus = !vm.showMoldLossStatus;
    if (vm.showMoldLossStatus) {
      defectService
        .getMoldLossStatus(vm.machine.shop.id, vm.defect.id)
        .then(function (data) {
          vm.moldLossStatusList = data;
        });
    }
  };

  var defectMarkIdentifier = "defectMarkID";
  var bottleIdentifier = "defectBottleID";

  vm.drawDefect = () => {
    if (!vm.defect || !vm.defect.locationX || !vm.defect.locationY) {
      return;
    }

    var elm = angular.element("#" + bottleIdentifier);
    if (!elm || !elm[0]) {
      return;
    }

    var x = vm.defect.locationX;
    var y = vm.defect.locationY;
    var img = new Image();
    img.className = "defect-mark";
    img.id = defectMarkIdentifier;
    img.style.position = "absolute";
    img.style.left = elm[0].offsetLeft + x - 5 + "px";
    img.style.top = elm[0].offsetTop + y + 12 + "px";
    elm.append(img);
  };

  var getSeverityName = function (severity) {
    return (<any>_.find(_.toArray(Enums.SEVERITY), { id: severity })).name;
  };

  var updateMoldRejectInputs = function () {
    if (vm.rejectStart) {
      vm.rejectStart = moment(vm.rejectStart).startOf("minute").toDate();
      vm.defect.rejectStart = vm.rejectStart;
    }
    if (vm.rejectEnd) {
      vm.rejectEnd = moment(vm.rejectEnd).startOf("minute").toDate();
      vm.defect.rejectEnd = vm.rejectEnd;
    }

    var timeZoneMoment = moment
      .tz(vm.defect.timeFound, vm.timeZoneId)
      .add(-30, "minutes");
    vm.minTime = moment(
      timeZoneMoment.format(Strings.TIME_FORMAT),
      Strings.TIME_FORMAT
    ).toDate();
  };

  vm.invokeMachineDefectQuestions = (isMnr: boolean) => {
    vm.machineDefectQuestions = [];
    if (
      vm.defect.severity === 1 ||
      vm.defect.severity === 2 ||
      (vm.defect.severity === 3 && vm.defect.defectTypeLegacyId === 901)
    ) {
      defectService
        .getMachineDefectQuestion(vm.defect.id, isMnr)
        .then((data) => {
          vm.machineDefectQuestions = data.map((i) => {
            return { ...i, isHEQuestion: i.question.indexOf("HE ") === 0 };
          });
          vm.defaultMachineDefectQuestions = angular.copy(
            vm.machineDefectQuestions
          );
        });
    }
  };

  vm.minRejectEnd = (): Date => {
    if (vm.rejectStart) {
      var timeZoneMoment = moment.tz(vm.rejectStart, vm.timeZoneId);
      return moment(
        timeZoneMoment.format(Strings.TIME_FORMAT),
        Strings.TIME_FORMAT
      ).toDate();
    }
    return vm.minTime;
  };

  vm.showCauses = false;
  if (data.defectId && data.defectId.length > 0 && !data.defect) {
    defectService
      .getDefect(data.defectId)
      .then((defectData: apsViewModels.DefectDetails) => {
        vm.defect = defectData;
        vm.moldLossEquipment = defectData.moldLossEquipment;
        shopId = defectData.isMachineShopId;
        vm.timeZoneId = defectData.isMachineShopPlantTimeZoneId;
        vm.machineNumber = defectData.isMachineNumber;
        vm.dropName = defectData.dropName;
        vm.sectionName = _.isNull(defectData.section)
          ? null
          : defectData.section.toString();
        vm.gobName = defectData.gobName;
        vm.severityName = getSeverityName(defectData.severity);
        vm.isMoldRejectInUse = defectData.isMoldRejectInUse;
        vm.isEquipmentFailure = defectData.isEquipmentFailure;
        vm.rejectStart = defectData.rejectStart;
        vm.rejectEnd = defectData.rejectEnd;
        vm.maintenanceStart = defectData.maintenanceStart;
        vm.maintenanceEnd = defectData.maintenanceEnd;
        vm.isFoodCertifiable = defectData.isFoodCertifiable;
        vm.maintenanceResolution = defectData.maintenanceResolution;
        vm.disableEquipment =
          apsEnums.EquipmentType[vm.moldLossEquipment] !== undefined
            ? true
            : false;

        vm.invokeMachineDefectQuestions(false);
        updateMoldRejectInputs();
        getDefectEquipment();
      });
  } else {
    vm.defect = data.defect;
    vm.moldLossEquipment = data.defect.moldLossEquipment;
    vm.isMoldRejectInUse = data.defect.isMoldRejectInUse;
    vm.isEquipmentFailure = data.defect.isEquipmentFailure;
    vm.rejectStart = data.defect.rejectStart;
    vm.rejectEnd = data.defect.rejectEnd;
    vm.maintenanceStart = data.defect.maintenanceStart;
    vm.maintenanceEnd = data.defect.maintenanceEnd;
    vm.isFoodCertifiable = data.defect.isFoodCertifiable;
    vm.maintenanceResolution = data.defect.maintenanceResolution;
    vm.gob = data.gob;
    vm.section = _.isNull(vm.gob) ? null : vm.gob.section;
    vm.machine = _.isNull(vm.section) ? null : vm.section.machine;
    vm.machineNumber = vm.machine.number;
    vm.dropName = data.defect.dropName;
    vm.sectionName =
      _.isNull(vm.section) ||
      _.isUndefined(vm.section.name) ||
      _.isNull(vm.section.name)
        ? null
        : vm.section.name.toString();
    vm.gobName =
      _.isNull(vm.gob) || _.isUndefined(vm.gob.name) || _.isNull(vm.gob.name)
        ? null
        : vm.gob.name.toString();
    shopActivity = vm.machine.shop;
    shopId = shopActivity.id;
    vm.timeZoneId = shopActivity.timeZoneId;
    vm.severityName = getSeverityName(vm.defect.severity);
    vm.showCauses = true;
    vm.disableEquipment =
      apsEnums.EquipmentType[vm.moldLossEquipment] !== undefined ? true : false;

    newGuidService.getNewGuid("moldLoss").then((x) => {
      var moldLoss: apsCommands.AddMoldLoss = {
        id: x,
        defectId: data.defect ? data.defect.id : undefined,
        plantId: $stateParams.plantId,
        critical:
          vm.defect.severity === apsEnums.Severity.Critical ? "Yes" : "No",
        isRejectInvalidMolds: vm.discardInvalidMolds,
        isRejectMold: vm.discardMold,
        shopId: shopId,
        moldId:
          data.defect && data.defect.toolNumber
            ? data.defect.toolNumber.toString()
            : undefined,
        reason:
          data.defect && data.defect.defectType && data.defect.defectType.name
            ? data.defect.defectType.name
            : "",
        requestedByUserId: $stateParams.userId,
        section: vm.section ? vm.section.sectionNumber : undefined,
        gob: data.gob ? data.gob.gobNumber : undefined,
        gobName: data.gob ? data.gob.name : undefined,
      };
      vm.moldLoss = moldLoss;
    });

    if (vm.maintenanceResolution !== null) {
      vm.isMaintenance = false;
    }
    vm.invokeMachineDefectQuestions(false);
    updateMoldRejectInputs();
    getDefectEquipment();
  }

  vm.defectNewComment = "";

  vm.cancel = function () {
    if (vm.hasMNRDataChange()) {
      uiUtilityService
        .confirm("Mold Reject updates are present.  Proceed with close?")
        .then((result) => {
          if (result) {
            $modalInstance.close();
          }
        });
    } else {
      $modalInstance.close();
    }
  };

  vm.formatTime = function (time) {
    return DateUtilityService.formatTime(time, vm.timeZoneId);
  };

  vm.defectCommentIsValid = function () {
    return (vm.defectNewComment || "").trim() !== "";
  };

  vm.addDefectComment = function () {
    if (vm.commentForm.$invalid) {
      return;
    }

    var defectComment = {
      shopId: shopId,
      defectId: vm.defect.id,
      comment: vm.defectNewComment,
    };
    var promise = defectService
      .addDefectComment(defectComment)
      .then(function () {
        $modalInstance.close();
      }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  vm.addHeldPallets = function () {
    if (vm.addHeldPalletsForm.$invalid) {
      return;
    }

    var command = {
      id: null,
      shopId: shopId,
      defectId: vm.defect.id,
      palletStart: vm.heldPalletStart,
      palletEnd: vm.heldPalletEnd,
    };

    var promise = defectService.addHeldPallets(command).then(function () {
      vm.heldPalletStart = null;
      vm.heldPalletEnd = null;
      vm.addHeldPalletsForm.$setPristine();
    }, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  vm.removeHeldPallet = function (
    heldPallet: apsViewModels.DefectDetailsHeldPallet
  ) {
    if (!heldPallet || heldPallet.id === "") {
      return;
    }

    var index = vm.defect.heldPallets.indexOf(heldPallet);
    if (index < 0) {
      return;
    }

    var command = {
      defectHeldPalletsId: heldPallet.id,
      shopId: shopId,
      defectId: vm.defect.id,
    };

    var promise = defectService
      .deleteHeldPallets(command)
      .then(function () {}, notifyService.handleApiErrors);
    loaderService.loadingPromise(promise);
  };

  vm.deleteDefect = () => {
    let result = openDeleteDefect(
      {
        defectName: vm.defect.name,
      },
      $modal
    );

    result.then((reason) => {
      if (!reason) {
        return;
      }

      let promise = defectService
        .deleteDefect(vm.defect.id, reason)
        .then(function () {
          $modalInstance.close();
        }, notifyService.handleApiErrors);
      loaderService.loadingPromise(promise);
    });
  };

  vm.reviewCausesAndCoursesOfAction = function () {
    $modalInstance.close(true);
  };

  vm.updateMNTData = function () {
    if (vm.defect.comments.length === 0) {
      vm.mntForm.maintenanceEnd.$setValidity("commentRequired", false);
    }
    if (vm.maintenanceResolution === null || !vm.isFoodCertifiable) {
      vm.mntForm.maintenanceEnd.$setValidity("maintRequired", false);
    }
    if (vm.mntForm.$invalid) {
      // force $dirty to show errors
      if (vm.mntForm.maintenanceStart) {
        vm.mntForm.maintenanceStart.$dirty = true;
      }

      if (vm.mntForm.maintenanceEnd) {
        vm.mntForm.maintenanceEnd.$dirty = true;
      }
      return;
    }

    var defectMNTData = {
      defectId: vm.defect.id,
      maintenanceStart: vm.isEquipmentFailure ? vm.maintenanceStart : null,
      maintenanceEnd: vm.isEquipmentFailure ? vm.maintenanceEnd : null,
      maintenanceResolution: vm.maintenanceResolution,
      isFoodCertifiable: vm.isFoodCertifiable,
    };

    var promise = defectService
      .updateDefectEquipFailure(defectMNTData)
      .then(() => {
        vm.defect.maintenanceStart = vm.maintenanceStart;
        vm.defect.maintenanceEnd = vm.maintenanceEnd;
      })
      .catch(notifyService.handleApiErrors);

    loaderService.loadingPromise(promise);
  };

  vm.updateMNTResolution = function () {
    vm.mntForm.maintenanceEnd = null;
    vm.maintenanceEnd = null;

    let resolutionTime = DateUtilityService.localToTimeZone(new Date(), vm.timeZoneId).toDate();
    data.defect.resolutionTime = resolutionTime;
    data.defect.resolvedBy = authDataService.getUserData().fullName;
    data.defect.maintenanceResolution = vm.maintenanceResolution;
    data.defect.isFoodCertifiable = vm.isFoodCertifiable;

    var defectMNTData = {
      defectId: vm.defect.id,
      maintenanceStart: vm.isEquipmentFailure ? vm.maintenanceStart : null,
      maintenanceEnd: vm.isEquipmentFailure ? vm.maintenanceEnd : null,
      maintenanceResolution: vm.maintenanceResolution,
      isFoodCertifiable: vm.isFoodCertifiable,
      resolvedBy: authDataService.getUserId(),
      resolutionTime: resolutionTime
    };
    var promise = defectService
      .updateDefectEquipFailure(defectMNTData)
      .then(() => {
        vm.defect.maintenanceStart = vm.maintenanceStart;
        vm.defect.maintenanceEnd = vm.maintenanceEnd;
        $modalInstance.close();
      })
      .catch(notifyService.handleApiErrors);

    loaderService.loadingPromise(promise);
  };
  vm.updateMNRData = function () {
    if (vm.mnrForm.$invalid) {
      // force $dirty to show errors
      if (vm.mnrForm.rejectStart) {
        vm.mnrForm.rejectStart.$dirty = true;
      }

      if (vm.mnrForm.rejectEnd) {
        vm.mnrForm.rejectEnd.$dirty = true;
      }
      return;
    }

    if (vm.defectQAForm.$invalid) {
      vm.machineDefectQuestions
        .filter((q) => !q.isHEQuestion)
        .forEach((q) => {
          if (q.questionValue === null || q.questionValue === undefined) {
            vm.defectQAForm[q.questionId].$dirty = true;
          }
        });
      return;
    }

    if (vm.moldLossEquipment === undefined || vm.moldLossEquipment === null) {
      if (vm.isMoldRejectInUse) {
        vm.moldLossForm.moldLossEquipment.$dirty = true;
        return;
      }
    }

    var defectMNRData = {
      defectId: vm.defect.id,
      isMoldRejectInUse: vm.isMoldRejectInUse,
      rejectStart: vm.isMoldRejectInUse ? vm.rejectStart : null,
      rejectEnd: vm.isMoldRejectInUse ? vm.rejectEnd : null,
      moldLossEquipment: vm.isMoldRejectInUse
        ? vm.moldLossEquipment
        : undefined,
      requalification: vm.showRequalification() ? vm.requalification : null,
      requalificationDateTime:
        vm.showRequalification() && vm.requalification
          ? vm.requalificationDateTime
          : null,
      questions: vm.getSelectedDefectsQuestions(),
    };

    var promise = defectService
      .updateDefectMoldReject(defectMNRData)
      .then(() => {
        vm.defect.isMoldRejectInUse = vm.isMoldRejectInUse;
        vm.defect.rejectStart = vm.rejectStart;
        vm.defect.rejectEnd = vm.rejectEnd;
        vm.defect.moldLossEquipment = vm.moldLossEquipment;
        vm.requalification = false;
        vm.requalificationDateTime = null;
        vm.disableEquipment =
          apsEnums.EquipmentType[vm.moldLossEquipment] !== undefined
            ? true
            : false;
        var moldLoss = getMoldLossData();
        defectService.addMoldLoss(moldLoss);
        $modalInstance.close();
      })
      .catch(notifyService.handleApiErrors);

    loaderService.loadingPromise(promise);
  };

  vm.getSelectedDefectsQuestions = function () {
    var selectedQuestions = [];
    let currentTimeInTimeZone = moment().tz(vm.timeZoneId);
    let currentTime = currentTimeInTimeZone.utc().toISOString();
    if (vm.machineDefectQuestions) {
      selectedQuestions = vm.machineDefectQuestions.map((question) => {
        let defaultValue = vm.defaultMachineDefectQuestions.filter(
          (q) => q.questionId === question.questionId
        )[0].questionValue;
        let userInput = question.questionValue;
        return {
          questionId: question.questionId,
          question: question.question,
          sequence: question.sequence,
          questionValue: userInput !== defaultValue ? userInput : defaultValue,
          lastUpdatedDate:
            userInput !== defaultValue ? currentTime : question.lastUpdatedDate,
          lastUpdatedBy:
            userInput !== defaultValue
              ? authDataService.getUserData().userName
              : question.lastUpdatedBy,
        };
      });
    } else {
      selectedQuestions = vm.defaultMachineDefectQuestions || null;
    }
    return selectedQuestions;
  };

  vm.hasMNRDataChange = function () {
    if (!vm.defect) {
      return false;
    }

    if (vm.defect.isMoldRejectInUse !== vm.isMoldRejectInUse) {
      return true;
    }

    if (vm.rejectStart) {
      if (
        !vm.defect.rejectStart ||
        vm.rejectStart.getTime() !== vm.defect.rejectStart.getTime()
      ) {
        return true;
      }
    } else if (vm.defect.rejectStart) {
      return true;
    }

    if (vm.rejectEnd) {
      if (
        !vm.defect.rejectEnd ||
        vm.rejectEnd.getTime() !== vm.defect.rejectEnd.getTime()
      ) {
        return true;
      }
    } else if (vm.defect.rejectEnd) {
      return true;
    }

    if (vm.requalification) {
      return true;
    }
    if (vm.machineDefectQuestions) {
      for (var defect of vm.machineDefectQuestions) {
        let defaultValue = vm.defaultMachineDefectQuestions.filter(
          (x) => x.questionId === defect.questionId
        )[0].questionValue;
        let currentValue = defect.questionValue;

        if (currentValue !== defaultValue) {
          return true;
        }
      }
    }
    return false;
  };
  vm.hasMNTDataChange = function () {
    if (!vm.defect) {
      return false;
    }

    if (vm.defect.isEquipmentFailure !== vm.isEquipmentFailure) {
      return true;
    }

    if (vm.maintenanceStart) {
      if (
        !vm.defect.maintenanceStart ||
        vm.maintenanceStart.getTime() !== vm.defect.maintenanceStart.getTime()
      ) {
        return true;
      }
    } else if (vm.defect.maintenanceStart) {
      return true;
    }

    if (vm.maintenanceEnd) {
      if (
        !vm.defect.maintenanceEnd ||
        vm.maintenanceEnd.getTime() !== vm.defect.maintenanceEnd.getTime()
      ) {
        return true;
      }
    } else if (vm.defect.maintenanceEnd) {
      return true;
    }
    return false;
  };
  vm.openCriticalDefectReport = function () {
    criticalDefectService.openReport(shopId, vm.defect).then((data) => {
      if (data) {
        $modalInstance.close();
      }
    });
  };

  vm.requalificationToggled = function () {
    if (vm.requalification) {
      vm.requalificationDateTime = vm.rejectEnd;
    } else {
      vm.requalificationDateTime = null;
    }
  };

  vm.showRequalification = function () {
    return (
      vm.canRequalify &&
      vm.isMoldRejectInUse &&
      !isNullOrUndefined(vm.rejectEnd) &&
      moment(vm.rejectEnd).isValid() &&
      isNullOrUndefined(vm.defect.rejectEnd)
    );
  };
}



// WEBPACK FOOTER //
// ./src/app/controllers/defects/viewDefect.controller.ts